module.exports = __webpack_public_path__ + "static/robot-board-5693120cc2f06a37a9f58abb6c49928e.svg";